import { requireDefault, requireModule } from './lib';

export { requireDefault, requireModule }

export default requireDefault
